<script>
    import Button from "../components/Button.svelte";
    import Logo from "../components/Logo.svelte";
    import Background from "../components/Background.svelte";
    import {links} from "../links";
</script>

<section id="purchase-action">
    <Background>
        <img class="bg-1" alt="background" src="images/index/purchase-bg-1.svg">
        <img class="bg-2" alt="background" src="images/index/purchase-bg-2.svg">
    </Background>
    <div style="padding: 12px 22px">
        <Logo/>
    </div>
    <div class="images">
        <img class="slogan" alt="红宝书在手 考研我无忧" src="images/index/slogan.svg"/>
        <img class="ad-image" alt="考研英语红宝书" src="images/index/purchase-image.png"/>
    </div>
    <div class="action-container">
        <div class="buttons">
            <Button icon="images/index/淘宝@1x.svg" text="淘宝购买" link={links.淘宝}/>
            <Button icon="images/index/京东@1x.svg" text="京东购买" link={links.京东}/>
        </div>
    </div>
</section>

<style>
    .bg-1 {
        position: absolute;
        top: 0;
        right: 0;
        width: 120px;
    }

    .bg-2 {
        position: absolute;
        top: 224px;
        left: 0;
        width: 144px;
    }

    .action-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .images {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .slogan {
        margin-top: 12px;
        width: 322px;
        height: 134px;

    }
    .ad-image {
        margin-top: 24px;
        width: 288px;
        height: 218px;
    }

    .action-container {
        margin: 44px 22px 0;
    }

    .buttons {
        width: 100%;
        display: grid;
        gap: 10px;
        align-items: center;
        grid-template-columns: repeat(auto-fit, 160px);
    }
</style>
